var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newsletter-create-page"},[_c('page-title',[_vm._v(_vm._s(_vm.$t('newsletters.create1')))]),_vm._v(" "),_c('create-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }